class PrevuraCampaignCountdown extends HTMLElement {
  connectedCallback() {
    this.endTime = Date.parse(this.dataset.end || '');
    this.status = this.querySelector('[data-campaign-status]');
    this.deadlineLabel = this.querySelector('[data-campaign-deadline]');
    this.units = {
      days: this.querySelector('[data-campaign-days]'),
      hours: this.querySelector('[data-campaign-hours]'),
      minutes: this.querySelector('[data-campaign-minutes]'),
      seconds: this.querySelector('[data-campaign-seconds]'),
    };

    if (!Number.isFinite(this.endTime)) {
      this.hidden = true;
      return;
    }

    this.#renderDeadline();
    this.#update();
    if (!this.hidden) this.interval = window.setInterval(() => this.#update(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.interval);
  }

  #renderDeadline() {
    if (!this.deadlineLabel) return;

    const formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'de-DE', {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    });
    this.deadlineLabel.textContent = `Gültig bis ${formatter.format(new Date(this.endTime))} Uhr`;
  }

  #update() {
    const remaining = this.endTime - Date.now();
    if (remaining <= 0) {
      window.clearInterval(this.interval);
      this.hidden = true;
      if (this.status) this.status.textContent = 'Der Aktionszeitraum ist beendet.';
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    };

    Object.entries(values).forEach(([unit, value]) => {
      if (this.units[unit]) this.units[unit].textContent = String(value).padStart(2, '0');
    });
  }
}

if (!customElements.get('prevura-campaign-countdown')) {
  customElements.define('prevura-campaign-countdown', PrevuraCampaignCountdown);
}

